import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/Layout';
import SEO from '../components/seo';
import RegisterForm from '../components/register/register_form';

import '../components/register/style.scss';

export const Register = ({
    entry,
    drawTicket,
    user,
    notification,
    game,
    actions,
}) => {
    const { loggedIn } = user;
    const submitFunction = user.loggedIn
        ? actions.userActions.update
        : actions.userActions.register;

    return (
        <Layout user={user} notification={notification} actions={actions}>
            <SEO title={loggedIn ? 'Update Account' : 'Register'} />
            <div className="register">
                <div className="upper-content">
                    <h1 className="title-section text-center">
                        {loggedIn ? 'Update Account' : 'Register'}
                    </h1>
                </div>
                <div className="lower-content">
                    <div className="inner-area">
                        <RegisterForm
                            user={user}
                            actions={actions}
                            submitFunction={submitFunction}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
